import React from "react";
import Button from "../../../../commons/components/Button";
import ButtonComponent from "../../../../commons/components/Forms/ButtonComponent";
import { currencyFormat, priceFormat } from "../../../../utils/helpers";
type Props = {
  steps: Object,
  paymentInApp: Function,
  loadingSubmit: Boolean
}

const InAppPaymentComponent = ({ steps, paymentInApp, loadingSubmit }: Props) => {
  const renderAmountPayment = () => {
    let use_money =steps?.step_4?.use_money || 0
    let amount = `${priceFormat(use_money*1000)}원`;
    return amount;
  }


  return (
    <div className="box-complete">
      <div className="box-complete__info">
        <div className="img">
          <img src={steps?.step_1?.character_pose_img?.thumbnail ??  steps?.step_1?.character_pose_img} />
        </div>
        <div className="description">
          <h4>{steps?.step_1?.character_name || ''}</h4>
          <div>{steps?.step_1?.character_pose_name || ''}</div>
          <p>{steps?.step_2?.title || ''}</p>
        </div>
      </div>
      <div className="box-complete__resuft">
        <span>총 결제 금액</span>
        <span>
          {renderAmountPayment()}
          {/* {
            steps?.step_4?.number_of_payments === '1pay' ? `${(steps?.step_4?.point_fill || 0)}원` : `0원`
          }   */}
        </span>
      </div>
      <p className="box-complete__noted">구매 후에는 전자상거래법 디지털 컨텐츠 환불 규정에 따라 처리 됩니다.</p>
      <div className="box-complete__button">
        {/* <Button customClass="btn-custom" isDisabled={loadingSubmit} onClick={() => paymentInApp()}>인앱 결제하기</Button> */}
        <ButtonComponent
          label={`인앱 결제하기`}
          customClass="btn btn-custom"
          handleClick={() => paymentInApp()}
          type={`button`}
          cssClass={`btn-custom`}
          style={{width: '100%'}}
          disabled={loadingSubmit}
        />
        
      </div>
      
    </div>
  )
}

export default InAppPaymentComponent;